// utils/apiConfig.js

import * as APPCONFIG from "../config/app-config";

/**
 * Returns the OpenRouter base URL based on current environment.
 * 
 * localhost → http://localhost:8083/
 * bmlv2.betalearnings.com/admin → https://bmlv2.betalearnings.com/
 * connect.yuukke.com/bcav2/... → https://connect.yuukke.com/
 */
export function getOpenRouterChatUrl() {
  const base = APPCONFIG.API_URL;

  if (base.includes("localhost") || base.includes("172.16.16.93")) {
    return "http://localhost:8083/api/openrouter/chat";
  }

  const url = new URL(base);
  return `${url.protocol}//${url.hostname}/YuukkeOpenRouter/api/openrouter/chat`;
}

export const OPENROUTER_CHAT_URL = getOpenRouterChatUrl();

/**
 * Full OpenRouter chat endpoint
 */
